import { render, staticRenderFns } from "./_cv-structured-list-item-selectable.vue?vue&type=template&id=1894913a&"
import script from "./_cv-structured-list-item-selectable.vue?vue&type=script&lang=js&"
export * from "./_cv-structured-list-item-selectable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports